/**
 * Service Romaneios (Terceiros) — CRUD do romaneio de carregamento.
 *
 * Cliente/pedido/ambiente vem da planilha legada (frontend, via useDados);
 * este service fala com o backend Django que PERSISTE o romaneio + ambientes
 * + itens. Cada funcao recebe `request` (do useAuth) como 1o argumento.
 */

const PREFIXO = "/api/romaneios";


export function listarRomaneios(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.situacao) usp.set("situacao", params.situacao);
  if (params.marcenaria) usp.set("marcenaria", params.marcenaria);
  if (params.num_pedido) usp.set("num_pedido", params.num_pedido);
  if (params.busca) usp.set("busca", params.busca);
  const qs = usp.toString();
  return request(`${PREFIXO}${qs ? `?${qs}` : ""}`);
}

export function obterRomaneio(request, id) {
  return request(`${PREFIXO}/${id}`);
}

export function criarRomaneio(request, dados) {
  return request(PREFIXO, { method: "POST", body: JSON.stringify(dados) });
}

export function atualizarRomaneio(request, id, dados) {
  return request(`${PREFIXO}/${id}`, {
    method: "PUT", body: JSON.stringify(dados),
  });
}

export function emitirRomaneio(request, id) {
  return request(`${PREFIXO}/${id}/emitir`, { method: "POST" });
}

export function excluirRomaneio(request, id) {
  return request(`${PREFIXO}/${id}`, { method: "DELETE" });
}


export const SITUACOES_ROMANEIO = [
  { value: "RASCUNHO", label: "Rascunho", tone: "neutral" },
  { value: "EMITIDO", label: "Emitido", tone: "success" },
];

export const SITUACAO_ROMANEIO_LABELS = Object.fromEntries(
  SITUACOES_ROMANEIO.map((s) => [s.value, s.label]),
);
export const SITUACAO_ROMANEIO_TONES = Object.fromEntries(
  SITUACOES_ROMANEIO.map((s) => [s.value, s.tone]),
);
